module.exports = ".scroller {\n  scrollbar-color: transparent transparent;\n}\n\n.scroller::-webkit-scrollbar {\n  display: none;\n}\n"